module.exports = __webpack_public_path__ + "img/mobile-product-case-index-metallurgy.aff5ce56.png";